import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import clientsApi from '@/features/dashboard/clients/api/clientsApi.ts';
import { clientsApiQueryKeys } from '@/features/dashboard/clients/api/clientsApi.queryKeys.ts';
import { BookingByTourClientDto } from '@/features/dashboard/clients/types/BookingByTourClientDto.ts';

const useGetClientBookingDetails = (clientId: string, tourId?: string) =>
  useQuery(getClientBookingDetailsQueryOptions(clientId, tourId));

export const getClientBookingDetailsQueryOptions = (
  clientId: string,
  tourId: string | undefined,
): UseQueryOptions<BookingByTourClientDto> => ({
  queryKey: clientsApiQueryKeys.bookingDetailsByTour(clientId, tourId ?? ''),
  queryFn: () => clientsApi.getBookingDetails(clientId, tourId!),
  enabled: !!tourId,
});

export default useGetClientBookingDetails;
